const homePressHeight = (homePressWrapper) => {
  homePressWrapper.forEach((element) => {
    const title = element.querySelector(".header-wrapper");
    const container = element.querySelector(".home-press__content-container");

    setTimeout(() => {
      if (title && container) {
        container.style.transform = `translateY(calc(90% - ${title.offsetHeight}px))`;
      }
    }, 400);
  });
};

export default homePressHeight;
